// Migrated
<template>
  <div
    ref="icon"
    :data-highlighted="highlighted"
  >
    <div
      v-if="active"
      :class="innerClass"
    >
      <div class="relative flex justify-center items-center">
        <template v-if="activeText !== null">
          <i-mapmarker-blue
            class="absolute"
            filled
            :font-controlled="false"
            :width="iconSize"
            @click="$emit('click')"
            @mouseover="$emit('mouseover')"
            @mouseout="$emit('mouseout')"
          />
          <span class="relative text-white font-bold">
            {{ activeText }}
          </span>
        </template>
        <i-mapmarker-blue-w-star
          v-else
          :width="iconSize"
          @click="$emit('click')"
          @mouseover="$emit('mouseover')"
          @mouseout="$emit('mouseout')"
        />
      </div>
    </div>
    <div
      v-else-if="hasIcon"
      :class="innerClass"
    >
      <slot />
    </div>
    <div
      v-else
      :class="innerClass"
    >
      <i-mapmarker-blue-new
        class="align-marker"
        filled
        :font-controlled="false"
        :width="iconSize"
        @click="$emit('click')"
        @mouseover="$emit('mouseover')"
        @mouseout="$emit('mouseout')"
      />
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  setup () {
    const instance = getCurrentInstance()

    return {
      parent: getCustomComponentParent(instance).ctx,
    }
  },

  props: {
    coordinates: {
      type: [Array, Object],
      required: true,
    },

    active: {
      type: Boolean,
      default: false,
    },

    activeText: {
      type: [String, Number],
      default: null,
    },

    offset: {
      type: Number,
      default: 0,
    },

    highlighted: {
      type: Boolean,
      default: false,
    },

    // Since a dynamic class removes the mapboxgl-* classes, we allow for an inner set class
    innerClass: {
      type: [Object, Array, String],
      default: null,
    },

    zIndex: {
      type: Number,
      default: 0,
    },
  },

  emits: ['click', 'mouseover', 'mouseout'],

  data () {
    return {
      marker: null,
      iconSize: 30,
      activeZIndex: 3,
    }
  },

  computed: {
    hasIcon () {
      return !!this.$slots.default?.()
    },
  },

  watch: {
    active () {
      this.handleZIndex()
    },

    zIndex () {
      this.handleZIndex()
    },
  },

  beforeUnmount () {
    if (this.marker) {
      this.marker?.remove()
    }
  },

  mounted () {
    this.handleZIndex()

    this.parent.onload(this.setMarker)
  },

  methods: {
    setMarker () {
      this.marker = new window.mapboxgl.Marker(this.$refs.icon)
        .setLngLat(this.coordinates)
        .setOffset([this.offset, 0])
        .addTo(this.parent.map)
    },

    handleZIndex () {
      if (this.zIndex) {
        this.$refs.icon.style.zIndex = this.zIndex
      } else if (this.active) {
        this.$refs.icon.style.zIndex = this.activeZIndex
      } else {
        this.$refs.icon.style.zIndex = null
      }
    },
  },
})
</script>

<style lang="scss">
.align-marker {
  padding-bottom: 100%;
}
</style>
